const NAMESPACE = 'PAPA';

// Define global namespace
window[NAMESPACE] = window[NAMESPACE] || {};

export default window[NAMESPACE];
